import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import BiddingCommentsList from 'components/organisms/bidding_comments_list';
import { BiddingState } from 'store/modules/bidding_store/types';
import { ApplicationState } from 'store';
import { useSelector, useDispatch } from 'react-redux';
import { getComments } from 'store/modules/bidding_store/actions';
import { Container } from './styles';

interface ModalNotesProps {
  modalNote: boolean;
  setModalNote: React.Dispatch<React.SetStateAction<boolean>>;
  bidding_id: number;
}

const ModalNotes = ({ modalNote, setModalNote, bidding_id }: ModalNotesProps) => {
  const dispatch = useDispatch();

  const { comments } = useSelector<ApplicationState, BiddingState>(
    (state) => state.session.biddings,
  );

  useEffect(() => {
    if (modalNote && bidding_id) {
      dispatch(getComments(String(bidding_id)));
    }
  }, [modalNote, bidding_id]);

  const commentsList = comments[bidding_id] || [];

  return (
    <Modal show={modalNote} size="lg" centered>
      <Container>
        <div className="modal-header bg-modal">
          <h6 className="modal-title text-white">Anotações</h6>
          <button
            aria-label="Close"
            className="close"
            type="button"
            onClick={() => setModalNote(false)}
          >
            <span aria-hidden="true" className="text-white">
              ×
            </span>
          </button>
        </div>
        <div
          className="p-3"
          style={{
            maxHeight: '60vh',
            overflowY: 'auto',
          }}
        >
          <BiddingCommentsList biddingId={bidding_id} comments={commentsList} />
        </div>
      </Container>
    </Modal>
  );
};

export default ModalNotes;
